import priceSimulator3dManifest from './price-simulator-3d/manifest';
import boxGeneratorManifest from './box-generator/manifest';
import operationalPurchasesManifest from './operational-purchases/manifest';

export const EXTENSION_CATALOG = [priceSimulator3dManifest, boxGeneratorManifest, operationalPurchasesManifest];

export const findExtension = (id) => EXTENSION_CATALOG.find((ext) => ext.id === id);
